// extracted by mini-css-extract-plugin
export default {"list":"styles_list__o0uPr","list_item":"styles_list_item__-q84x","list_title":"styles_list_title__408Rn","list_link":"styles_list_link__SpePW"};